module.exports = __webpack_public_path__ + "img/chinesecompany221.7c3a303d.png";